
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      pages: [],
    };
  },
  computed: {
    isChildren () {
      return this.post.acf.page_index_config.index_type === `children`;
    },
    showExcerpt () {
      return this.post.acf.page_index_config.show_excerpt;
    },
    showLinkText () {
      return this.post.acf.page_index_config.show_link_text;
    },
    background () {
      return this.post.acf.page_index_config.background;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getPages();
    });
  },
  methods: {
    async getPages () {
      const queryParams = {
        fields: `id,title,slug,excerpt,type,image,link,slug,acf`,
        posts: {
          post_type: [`any`],
          posts_per_page: 50,
          post_parent: this.isChildren ? this.post.id : ``,
          orderby: this.isChildren ? `menu_order` : `post__in`,
          order: `asc`,
          post_status: `publish`,
        },
        options: {
          image_size: `medium_large`,
        },
      };

      if (this.isChildren) {
        queryParams.posts.post_parent = this.post.id;
      } else {
        queryParams.posts.post__in = this.post.acf.page_index_config.pages.map(page => parseInt(page.ID));
      }

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.pages = request;
      }
    },
  },
};
